/**
 * 后端接口地址
 */
export const Config = {
  /**
   * 获取公钥
   */
  getPublicKey: 'GET /public/key',
  /**
   * 获取图形验证码
   */
  getVerifyCode: 'GET /user/verify-code',
  /**
   * 用户登录
   */
  userLogin: 'POST /user/login',
  /**
   * 用户登录
   */
  userLogout: 'POST /user/logout',
  /**
   * 获取应用
   */
  getApps: 'GET /user/apps',
    /**
   * 获取导航
   */
    getNavs: 'GET /user/navs',
  /**
   * 获取权限点
   */
  getFunctions: 'GET /user/functions',
  /**
   * 获取用户信息
   */
  getUser: 'GET /user/identity',
  /**
   * 更新密码
   */
  updatePassword: 'POST /user/reset-password'
}
